import React, { Component, Fragment } from 'react';
// import spinner from './Wedges-3s-200px.gif';
import spinner2 from './Ripple-1s-200px.gif'


export class Snipper extends Component {
    render() {
        return (
            <Fragment>
                <img src={spinner2} alt="Loading..." style={{width: '100px',margin:'auto',display:'block'}}/>
            </Fragment>
        )
    }
}

export default Snipper
